import $ from "jquery";

export default function () {
  let cur_video = null;

  setTimeout(function () {
    $(".shopify-section.video-slider-section").css("opacity", "1");
  }, 100);

  $("[data-video-section-wrapper] [data-video-play]").css("opacity", "1");
  play_video();

  $(document).scroll(function () {
    play_video();
  });

  function play_video() {
    var $videoWrapper = $("[data-video-slider]");
    var $video = $("[data-video-slider-item]");
    var scroll = $(document).scrollTop();
    $videoWrapper.each(function () {
      $(this)
        .find("[data-video-slider-item]")
        .each(function (idx) {
          var offset = $(this).offset().top;
          var sectionHeight = $(this).height();
          var margin = 100;
          var mob_margin = 0;
          if ($(window).width() < 768) {
            margin = 100;
            mob_margin = $(this).find(".text_wrapper").height();
          }
          if (scroll + sectionHeight + margin > offset + mob_margin) {
            if ($(this).attr("data-active") != "true") {
              var $videoForm = $(this).find(".section-video_form");
              var _this = $(this);
              if ($videoForm.length > 0) {
                videoControl($videoForm, "play");
              }

              $(this).find("[data-video-control]").attr("data-play", "true");
              $(this).attr("data-active", "true");
            } else {
              if (scroll - sectionHeight / 2 > offset) {
                var $videoForm = $(this).find(".section-video_form");
                // videoControl($videoForm, 'pause');
                // $(this).find('[data-video-control]').attr('data-play', 'false');
              } else {
                var $videoForm = $(this).find(".section-video_form");
                var _this = $(this);
                // videoControl($videoForm, 'play');

                // $(this).find('[data-video-control]').attr('data-play', 'true');
              }
            }
          }

          var $indicator = $(this)
            .closest("[data-video-section-wrapper]")
            .find("[data-sticky-indicator]");

          if (scroll + sectionHeight / 2 > offset) {
            $indicator
              .find("[data-indicator-dots]")
              .find("span")
              .removeClass("active");
            $indicator
              .find("[data-indicator-dots]")
              .find("span")
              .eq(idx)
              .addClass("active");
            idx += 1;
            $indicator
              .find("[data-indicator-count]")
              .find("[data-current-index]")
              .text(idx);
          }

          if (scroll + sectionHeight / 2 > offset - 25) {
            // $indicator.css('opacity', 0);
          }
          if (
            scroll + sectionHeight / 2 >
            offset + $indicator.find(".wrapper").height()
          ) {
            // $indicator.css('opacity', 1);
          }
        });
    });
  }

  setTimeout(function () {
    $("[data-video-section-wrapper]").each(function () {
      var $this = $(this);
      var $indicator = $this.find("[data-sticky-indicator]");
      var $slider = $this.find("[data-video-slider]");
      var offset = $this.offset().top;
      var topSpacing =
        $slider.find("[data-video-slider-item]:first-child").height() / 2;
      var height =
        $slider.find("[data-video-slider-item]:last-child").height() / 2;

      $indicator.css({
        top: topSpacing,
        "margin-top": topSpacing,
        height: height,
        opacity: 1,
      });
    });
  }, 1000);

  $("[data-sticky-indicator] [data-indicator-dots] span").on(
    "click",
    function () {
      var handle = $(this).attr("data-target");
      var $target = $(this)
        .closest("[data-video-section-wrapper]")
        .find("#" + handle);
      var scrollTop = $target.offset().top - $target.height() / 2 + 30;
      $("html, body").animate(
        {
          scrollTop: scrollTop,
        },
        500,
      );
    },
  );

  $("[data-video-play]").on("click", function () {
    $(this).closest("[data-video-control]").attr("data-play", "true");
    var $videoForm = $(this)
      .closest("[data-video-slider-item]")
      .find(".section-video_form");
    videoControl($videoForm, "play");
  });

  $("[data-video-pause]").on("click", function () {
    $(this).closest("[data-video-control]").attr("data-play", "false");
    var $videoForm = $(this)
      .closest("[data-video-slider-item]")
      .find(".section-video_form");
    videoControl($videoForm, "pause");
  });

  function videoControl($videoForm, handle) {
    var $_videoForm = null;
    var _width = $(window).width();
    $videoForm.each(function () {
      if (_width > 989 && $(this).hasClass("hide--mobile")) {
        $_videoForm = $(this);
      }
      if (_width < 990 && $(this).hasClass("hide--desktop")) {
        $_videoForm = $(this);
      }
    });

    if (handle == "play") {
      if ($_videoForm?.hasClass("video")) {
        $_videoForm.find("#videoId").get(0).play();
        $_videoForm.find("#videoId").on("ended", function () {
          $_videoForm
            .closest("[data-video-slider-item]")
            .find("[data-video-control]")
            .attr("data-play", "false");
        });
      } else if ($_videoForm?.hasClass("external_video")) {
        var $video = $_videoForm.find("iframe");
        var src = $video.attr("src");
        src +=
          "?rel=0&loop=1&title=0&byline=0&portrait=0&sidedock=0&autoplay=1&playsinline=1&muted=1";
        $video.attr("src", src);
      }
    } else if (handle == "pause") {
      if ($_videoForm?.hasClass("video")) {
        $_videoForm.find("#videoId").get(0).pause();
      } else if ($_videoForm?.hasClass("external_video")) {
        var $video = $_videoForm.find("iframe");
        var src = $video.attr("src");
        src = src.split("?")[0];
        $video.attr("src", src);
      }
    }
  }
}
